export default __webpack_public_path__ + "static/media/Navigation.bbafce59.svg";